/** Tiptap-free, so plain inputs can share the rules without loading the editor (BRE-8381). */

/**
 * Typed character pairs converted to a symbol as the user types (BRE-7787).
 *
 * Deliberately excluded: `--` (would break typing `---` for a horizontal rule),
 * `x`/`*` to multiplication (collides with emphasis), and smart quotes,
 * ellipsis, legal marks and fractions.
 */
export const SYMBOL_SHORTCUTS: readonly { find: RegExp; replacement: string }[] = [
  { find: /->$/, replacement: "→" },
  { find: /<-$/, replacement: "←" },
  // `<-` has already become `←` by the time `>` is typed.
  { find: /←>$/, replacement: "↔" },
  { find: /=>$/, replacement: "⇒" },
  { find: /!=$/, replacement: "≠" },
  { find: /<=$/, replacement: "≤" },
  { find: />=$/, replacement: "≥" }
];

/** True when `textBefore` ends inside a backtick span that has not been closed yet. */
export function hasOpenInlineCode(textBefore: string): boolean {
  return (textBefore.split("`").length - 1) % 2 === 1;
}

/**
 * True when the whitespace-delimited token ending `textBefore` holds a URL
 * start (`://` or `www.`), even after punctuation like `(`. Linear in the
 * token length: this runs on every shortcut keystroke, and an unanchored
 * scheme regex rescans long tokens quadratically.
 */
export function endsInUrl(textBefore: string): boolean {
  let start = textBefore.length;
  while (start > 0 && !/\s/.test(textBefore[start - 1])) start -= 1;
  const token = textBefore.slice(start);
  return token.includes("://") || /(?:^|[^a-z0-9])www\./i.test(token);
}
